@if (searchInfo.length > 0 || searchGroupInfos.length > 0) {
    <div class="text_white_searchresult">
        
        <strong>{{'genericSearch.searchWords' | hisUi }}:</strong>
        
        @if (searchInfo.length > 0) {
    	    @for (searchInfoItem of searchInfo; track searchInfoItem) {
    	        @if (searchInfoItem.value) {
    		        {{searchInfoItem.label}}
    		        @if (searchInfoItem.not) {
                        {{searchInfoItem.not}}
                    }
    		        {{searchInfoItem.value}}
    	        }
    	    }
    	}
        
        <!-- Kriteriengruppen -->
        @if (searchGroupInfos.length > 0) {
            <strong>{{'genericSearch.criteriaGroups' | hisUi }}:</strong>
            
            @for (groupWithCriteriaGroup of searchGroupInfos; track groupWithCriteriaGroup) {
            
                @if (!groupWithCriteriaGroup.criteriaGroupOr) {
    				<ul>
    			        @for (criteriaGroupInfo of groupWithCriteriaGroup.searchInfoCriteriaGroup; track criteriaGroupInfo) {
    						<li>
    							@if (criteriaGroupInfo.excluding) {
    								<strong> {{'genericSearch.criteriaGroup.exclude' | hisUi }}:</strong>
    							} @else {
    								<strong> {{'genericSearch.criteriaGroup.include' | hisUi }}:</strong>
    							}
    							
    					        @for (criteriaGroupItem of criteriaGroupInfo.searchCriteriaGroupItems; track criteriaGroupItem) {
    					            @if (criteriaGroupItem.value) {
                                    	<!-- criteriaGroupItem.not sollte ein boolean -->
                                    	<!-- label sollte labelKey heißen -->
    									{{criteriaGroupItem.label}}
    									@if (criteriaGroupItem.not) {
                                            {{criteriaGroupItem.not}}
                                        }
    									{{criteriaGroupItem.value}}
    								}
    						    }
    				        </li>
    				    }
    			    </ul>
    		    }
            	
            	@if (groupWithCriteriaGroup.criteriaGroupOr) {
                    <ul class="listStyleIconSimple">
    				    <li><strong>{{groupWithCriteriaGroup.criteriaGroupOr}}</strong></li>
    				    <ul>
    		                @for (criteriaGroupInfo of groupWithCriteriaGroup.searchInfoCriteriaGroup; track criteriaGroupInfo) {
    							<li>
    								@if (criteriaGroupInfo.excluding) {
    									<strong> {{'genericSearch.criteriaGroup.exclude' | hisUi }}:</strong>
    								} @else {
    									<strong> {{'genericSearch.criteriaGroup.include' | hisUi }}:</strong>
    								}
    								
    						        @for (criteriaGroupItem of criteriaGroupInfo.searchCriteriaGroupItems; track criteriaGroupItem) {
    						            @if (criteriaGroupItem.value) {
    										{{criteriaGroupItem.label}}
    										@if (criteriaGroupItem.not) {
                                                {{criteriaGroupItem.not}}
                                            }
    										{{criteriaGroupItem.value}}
    									}
    						        }
    					        </li>
    					    }
    					</ul>
    				</ul>
                }
    	    }
    	}
    </div>
}
